import {Inject, Injectable} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import {PLATFORM_ID} from '@angular/core';
import {filter} from 'rxjs/operators';
import {Observable, Subject, Subscription} from 'rxjs';

@Injectable({providedIn: 'root'})
export class NavigationCancelService {
  private readonly cancelSubject = new Subject<number>();
  private routerSubscription?: Subscription;
  private hasNavigated = false;
  private navigationEpoch = 0;
  public readonly cancel$: Observable<number> = this.cancelSubject.asObservable();

  public getCurrentEpoch(): number {
    return this.navigationEpoch;
  }

  constructor(
    private readonly router: Router,
    @Inject(PLATFORM_ID) private readonly platformId: object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.routerSubscription = this.router.events
        .pipe(filter((event) => event instanceof NavigationStart || event instanceof NavigationEnd))
        .subscribe((event) => {
          if (event instanceof NavigationEnd) {
            this.hasNavigated = true;
            return;
          }
          if (this.hasNavigated) {
            const currentPath = this.normalizePath(this.router.url);
            const nextPath = this.normalizePath(event.url);
            if (currentPath === nextPath) {
              return;
            }
            this.navigationEpoch += 1;
            this.cancelSubject.next(this.navigationEpoch);
          }
        });
    }
  }

  private normalizePath(url: string): string {
    const [pathWithNoHash] = url.split('#');
    const [path] = pathWithNoHash.split('?');
    const trimmed = path.replace(/\/+$/, '');
    // Event tabs share the mounted detail view and its pending media requests.
    // Award detail pages use /events/awards/:awardId and are separate views.
    const eventTab = trimmed.match(/^\/events\/([^/]+)\/(?:general|discussion|media|participants|awards)$/);
    if (eventTab && eventTab[1] !== 'awards') {
      return `/events/${eventTab[1]}`;
    }
    return trimmed || '/';
  }
}
